import React from 'react';
import styled from 'styled-components';

import { Link } from 'react-router-dom'

const ImgLogo = styled.div`
  width: 180px;
  height: 58px;
  background: url('/Biterica-green-white.png') no-repeat center center;
  background-size: contain;
  
@media (max-width: 800px) {
  margin-left: 15px;
  width: 180px;
  height: 44px;
}
`;

const Logo = () => (<Link to={'/'}><ImgLogo /></Link>);

export default Logo;


// WEBPACK FOOTER //
// ./src/Components/Logo.js